// src/components/About/About.jsx

import React, { useEffect, useRef, useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import '../../../../assets/css/Buyer/Home/aboutUs.css';
import { FaArrowRight } from 'react-icons/fa';

const About = () => {
  const sectionRef = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect(); // sirf ek baar animate
        }
      },
      { threshold: 0.35 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    
    return () => observer.disconnect();
  }, []);
  const cardsData = [
    {
      id: 1,
      title: 'High ROI',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&h=400&fit=crop',
      badge: 'Join Our Team',
      link: '#',
      // Position - Top Left
      position: { top: '60%', left: '5%' },
      // Animation - Left se aayega
      animationClass: 'card-slide-left',
      animationDelay: '1.6s'
    },
    {
      id: 2,
      title: 'Prime locations',
      image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=400&fit=crop',
      badge: 'Join Our Team',
      link: '#',
      // Position - Bottom Left
      position: { top : '60%', left: '28%' },
      // Animation - Bottom se aayega
      animationClass: 'card-slide-bottom',
      animationDelay: '1.9s'
    },
    {
      id: 3,
      title: 'Trusted by 2k+ investors',
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop',
      badge: 'Join Our Team',
      link: '#',
      // Position - Top Right
      position: { top: '60%', right: '5%' },
      // Animation - Top se aayega
      animationClass: 'card-slide-top',
      animationDelay: '2.2s'
    },
    {
      id: 4,
      title: 'Expert insights',
      image: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?w=600&h=400&fit=crop',
      badge: 'Join Our Team',
      link: '#',
      // Position - Bottom Right
      position: { top: '60%', right: '28%' },
      // Animation - Right se aayega
      animationClass: 'card-slide-right',
      animationDelay: '2.5s'
    }
  ];

  return (
    <section  ref={sectionRef}
      className={`about-section ${show ? 'about-show' : ''}`}>
      <Container fluid className="about-container">
        
        {/* Background Layer - Hero Text (0-1s animation) */}
        <div className="about-hero-layer">
          
          {/* Small subtitle - "Who We Are" */}
          <p className="about-subtitle hero-animate-fade">
            Who We Are
          </p>
          
          {/* Main Large Heading - Centered */}
          <h1 className="about-main-title hero-animate-slide">
            We are a next-generation platform combining AI-driven property 
            analytics and blockchain-secured transactions to revolutionize 
            the real estate investment process
          </h1>
          
          {/* About Us Button - Black rounded button 
          <a href="#" className="explore-btn">
                <span>About us</span>
            <div className="btn-icon">
              <FaArrowRight />
            </div>
          </a>*/}
          
        </div>
        <div className="cards-floating-layer">
              {cardsData.map((card) => (
                <div
                  key={card.id}
                  className={`floating-card ${show ? card.animationClass : ''}`}
                  style={{
                    ...card.position,
                    animationDelay: show ? card.animationDelay : '0s'
                  }}
                >
                  {/* Card with angled/clipped corners */}
                  <div className="card-clipped-shape">
                    
                    {/* Card Image Section */}
                    <div className="card-image-wrapper">
                      <img 
                        src={card.image} 
                        alt={card.title}
                        className="card-image"
                      />
                      
                      {/* Join Our Team Badge - Top Right */}
                      <div className="card-badge">
                        {card.badge}
                      </div>
                      
                      {/* Card Title - Bottom Left Overlay */}
                      <div className="card-title-overlay">
                        <h3>{card.title}</h3>
                        <div className="card-consultation-link">
                      Get Consultation <FaArrowRight className="arrow-icon" />
                      </div>
                      </div>
                      {/* Get Consultation Link - Below Image */}
                      
                    </div>
                  </div>
                </div>
              ))}
            </div>

        {/* Foreground Layer - Animated Cards (1-4s animation) */}
        {/* Cards text ke upar float karengi */}
        {/*<AboutCards show={show}/>*/}
        
      </Container>
    </section>
  );
};

export default About;